<script setup>
import { defineProps, computed } from 'vue';
import store from '../../state/store';
import moment from 'moment';

const userRoles = computed(() => JSON.parse(localStorage.getItem('roles')));
const loading = computed(() => store.state.globals.loading);

const props = defineProps({
    timeline: {
        type: [Array, null],
        required: true
    }
});

const parseTimelineToJSON = (string) => {
    if (!string) return '';
    const data = JSON.parse(string);

    let text = '';
    for (const key in data) {
        if (userRoles.value && userRoles.value.length) {
            if(!userRoles.value.some((obj) => (obj.slug === "lto-record"))){
                if(key == "owner_name" ||
                    key == "owner_address"
                )
                    continue;
            }
        }
       text += `<strong>${key.replaceAll("_", " ")}:</strong> ${data[key]}<br/>`;
    }
    return text;
}

const parseVehicleRecordToJSON = (string) => {
    if (!string) return '';
    if (!JSON.parse(string).MotorVehicle) return '';

    const data = JSON.parse(string).MotorVehicle;

    let text = '';
    for (const key in data) {
        if (userRoles.value && userRoles.value.length) {
            if(!userRoles.value.some((obj) => (obj.slug === "lto-record"))){
                if(key == "owner_name" ||
                    key == "owner_address"
                )
                    continue;
            }
        }
       text += `<strong>${key.replaceAll("_", " ")}:</strong> ${data[key]}<br/>`;
    }
    return text;
}

</script>

<template>
    <b-overlay :show="loading">
        <div v-if="props.timeline.length" class="timeline">
            <div class="timeline-item right" v-for="(timeline, index) in props.timeline" :key="index">
                <i v-if="timeline.chapter === 'CAPTURED BY CAMERA'" class="icon ri-camera-line"></i>
                <i v-else-if="timeline.chapter === 'INPUT PHASE'" class="icon ri-pencil-line"></i>
                <i v-else-if="timeline.chapter === 'UPDATE VIOLATION'" class="icon ri-direction-fill"></i>
                <i v-else-if="timeline.chapter === 'VERIFY PHASE'" class="icon  ri-route-line"></i>
                <i v-else-if="timeline.chapter === 'VALIDATE PHASE'" class="icon ri-checkbox-line"></i>
                <i v-else-if="timeline.chapter === 'VALIDATE'" class="icon ri-checkbox-line"></i>
                <i v-else-if="timeline.chapter === 'LGU APPROVAL'" class="icon ri-vip-crown-line"></i>
                <i v-else-if="timeline.chapter === 'LGU APPROVAL PHASE'" class="icon ri-vip-crown-line"></i>
                <i v-else-if="timeline.chapter === 'LTO GET RECORDS - DERMALOG.'" class="icon ri-suitcase-line"></i>
                <i v-else-if="timeline.chapter === 'LTO GET RECORDS - DERMALOG'" class="icon ri-suitcase-line"></i>
                <i v-else-if="timeline.chapter === 'LTO GET RECORDS - STRADCOM'" class="icon ri-suitcase-line"></i>
                <i v-else-if="timeline.chapter === 'LOGISTICS: PROCESSING'" class="icon ri-flight-land-line"></i>
                <i v-else-if="timeline.chapter === 'LOGISTICS: READY FOR DELIVERY'" class="icon ri-flight-land-line"></i>
                <i v-else-if="timeline.chapter === 'LOGISTICS: IN TRANSIT TO COURIER'" class="icon ri-flight-land-line"></i>
                <i v-else-if="timeline.chapter === 'LOGISTICS: RECEIVED BY COURIER'" class="icon ri-flight-land-line"></i>
                <i v-else-if="timeline.chapter === 'LOGISTICS: IN TRANSIT'" class="icon ri-flight-land-line"></i>
                <i v-else-if="timeline.chapter === 'LOGISTICS: DELIVERED'" class="icon icon ri-truck-line"></i>
                <i v-else-if="timeline.chapter === 'LOGISTICS: RETURNED'" class="icon icon ri-restart-line"></i>
                <i v-else-if="timeline.chapter === 'PAYMENT'" class="icon ri-money-cny-circle-line"></i>
                <i v-else-if="timeline.chapter === 'LTO GET RECORDS'" class="icon ri-database-2-line"></i>
                <i v-else-if="timeline.chapter === 'DATABASE PROCESS'" class="icon ri-cpu-line"></i>
                <i v-else-if="timeline.chapter === 'INPUT REJECTED'" class="icon  ri-stop-line"></i>
                <i v-else class="icon ri-vip-diamond-line"></i>
                <div class="date">{{ timeline.created_at ? moment(timeline.created_at).format('ddd, D MMM YYYY hh:mm:ss A') : '' }}</div>
                <div class="content">
                    <b-accordion class="righticon-accordion custom-accordionwithicon" style="border: none" id="accordionlefticon">
                        <b-accordion-item :title="timeline.chapter">
                            <p v-if="timeline.data === 'No LTO Records'" class="text-muted mb-2 text-uppercase">
                                {{ timeline.data }}
                            </p>
                            <p v-else-if="(['READYFORDELIVERY', 'INTRANSITTOCOURIER', 'INTRANSIT', 'DELIVERED', 'RETURNED']).includes(JSON.parse(timeline.data))" class="text-muted mb-2 text-uppercase">
                                {{ JSON.parse(timeline.data) }}      
                            </p>
                            <p v-else-if="timeline.data" class="text-muted mb-2 text-uppercase"
                                v-html="parseTimelineToJSON((timeline.data))">
                            </p>
                            <span class="text-uppercase text-muted" v-if="timeline.vehicle_record && timeline.vehicle_record.raw">
                                Code: {{ JSON.parse(timeline.vehicle_record.raw).Code || 'n/a' }}
                            </span>
                            <p v-if="timeline.vehicle_record && timeline.vehicle_record.raw" class="text-muted mb-2 text-uppercase"
                                v-html="parseVehicleRecordToJSON(timeline.vehicle_record.raw)">
                            </p>
                        </b-accordion-item>
                    </b-accordion>
                </div>
            </div>
            <div class="timeline-item right"></div>
        </div>
        <div v-else class="timeline">
            <div class="timeline-item right">
                <i class="icon ri-vip-diamond-line"></i>
                <div class="date">{{ moment().format('ddd, D MMM YYYY') }}</div>
                <div class="content">
                    <h6>Timeline for this file # hasn't been recorded yet!</h6>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<style>
    .timeline::after {
        width: 1px !important;
        background: #45CB85;
    }

    .timeline-item {
        padding: 13px 60px !important; 
    }

    .timeline-item .content {
        padding: 0 !important;
    }

    .timeline-item .icon {
        padding: 10px 0 !important;
        top: 11px !important;
    }

    .timeline-item .date {
        top: 30px !important;
    }
</style>